export type LoginApiName = 'phato' | 'laureano' | 'laureanoSoul' | 'hnsn';

export type PhonePresence = 'exists' | 'missing' | 'unavailable';

const OTP_REQUIRED_APIS: LoginApiName[] = [
  'phato',
  'laureano',
  'laureanoSoul',
];

export const SUPPORT_PHONE_MESSAGE =
  'Não encontramos um telefone cadastrado para envio do código. Entre em contato com o suporte.';

export const PHATO_PHONE_UNAVAILABLE_MESSAGE =
  'Não foi possível verificar o telefone cadastrado. Tente novamente mais tarde ou entre em contato com o suporte.';

export function isAdminLogin(login: string) {
  const normalized = login.replace(/\D/g, '');
  return normalized === '00009' || normalized === '00000';
}

export function getSuccessfulApiNames<T>(
  results: PromiseSettledResult<T>[],
  names: LoginApiName[],
) {
  return results.reduce<LoginApiName[]>((successfulApis, result, index) => {
    if (result.status === 'fulfilled') successfulApis.push(names[index]);
    return successfulApis;
  }, []);
}

export function requiresOtpChallenge(successfulApis: LoginApiName[]) {
  return successfulApis.some((api) => OTP_REQUIRED_APIS.includes(api));
}

export function hasRegisteredPhone(statuses: PhonePresence[]) {
  return statuses.some((status) => status === 'exists');
}

export function interpretPhoneExistsStatus(status: number): PhonePresence {
  if (status === 204) return 'missing';
  if (status >= 200 && status < 300) return 'exists';
  return 'unavailable';
}

export function interpretPhoneResourceStatus(
  status: number,
  hasBody: boolean,
): PhonePresence {
  if (status === 204 || status === 404) return 'missing';
  if (status >= 200 && status < 300 && hasBody) return 'exists';
  if (status >= 200 && status < 300) return 'missing';
  return 'unavailable';
}

export function getPhatoPhoneExistsEndpoint(
  isMedico: boolean,
  normalizedLogin: string,
) {
  const entity = isMedico ? 'medico' : 'paciente';
  return `/v2/${entity}/${normalizedLogin}/telefone-existe`;
}

/** Mesmo endpoint que a api-auth usa para ler o telefone no Patho. */
export function getPhatoPhoneResourceEndpoint(
  isMedico: boolean,
  normalizedLogin: string,
) {
  const entity = isMedico ? 'medico' : 'paciente';
  return `/v2/${entity}/${normalizedLogin}/telefone`;
}

export function getPhatoPhoneRegisterEndpoint(isMedico: boolean) {
  const entity = isMedico ? 'medico' : 'paciente';
  return `/v2/${entity}/telefone`;
}

/** Mesmo endpoint que a api-auth usa para ler o telefone no Laureano MV. */
export function getLaureanoPhoneEndpoint(
  isMedico: boolean,
  normalizedLogin: string,
) {
  const entity = isMedico ? 'medico' : 'paciente';
  return `/${entity}/${normalizedLogin}/telefone`;
}

export function buildDoctorPhonePayload({
  login,
  password,
  ddd,
  number,
}: {
  login: string;
  password: string;
  ddd: string;
  number: string;
}) {
  return {
    CD_PRESTADOR: login.replace(/\D/g, ''),
    CPF: password.replace(/\D/g, ''),
    NR_DDD_CELULAR: ddd,
    NR_CELULAR: number,
  };
}
